/* eslint-disable no-underscore-dangle */
((ns) => {
  const { logError } = ns;

  const initViewToggle = () => {
    try {
      const filterComponent = document.querySelector("filter-component");
      if (!filterComponent) return;

      // Get view toggle buttons
      const buttonList = filterComponent.querySelector(".view-as__list-button");
      const buttonGrid = filterComponent.querySelector(".view-as__grid-button");

      // Get the hits container
      const hitsContainer = document.querySelector("#hits");

      if (!buttonList || !buttonGrid || !hitsContainer) return;

      // Remove existing event listeners to prevent duplicates
      const newButtonGrid = buttonGrid.cloneNode(true);
      const newButtonList = buttonList.cloneNode(true);
      buttonGrid.parentNode.replaceChild(newButtonGrid, buttonGrid);
      buttonList.parentNode.replaceChild(newButtonList, buttonList);

      // Add click handlers
      newButtonGrid.addEventListener("click", () => {
        try {
          // Update button states
          newButtonGrid.querySelector(".view-as__icon").classList.add("view-as__icon--active");
          newButtonList.querySelector(".view-as__icon").classList.remove("view-as__icon--active");

          // Update container class for grid view
          hitsContainer.classList.remove("search-products--list");
          hitsContainer.classList.add("search-products--grid");

          // Save preference
          localStorage.setItem("searchViewMode", "grid");

          // Trigger InstantSearch re-render
          if (window.__instantSearchInstance) {
            window.__instantSearchInstance.refresh();
          }
        } catch (error) {
          logError(error, "toggleGridView");
        }
      });

      newButtonList.addEventListener("click", () => {
        try {
          // Update button states
          newButtonList.querySelector(".view-as__icon").classList.add("view-as__icon--active");
          newButtonGrid.querySelector(".view-as__icon").classList.remove("view-as__icon--active");

          // Update container class for list view
          hitsContainer.classList.remove("search-products--grid");
          hitsContainer.classList.add("search-products--list");

          // Save preference
          localStorage.setItem("searchViewMode", "list");

          // Trigger InstantSearch re-render
          if (window.__instantSearchInstance) {
            window.__instantSearchInstance.refresh();
          }
        } catch (error) {
          logError(error, "toggleListView");
        }
      });

      // Apply saved preference on load
      const savedView = localStorage.getItem("searchViewMode") || "grid";
      if (savedView === "list") {
        newButtonList.click();
      } else {
        newButtonGrid.click();
      }
    } catch (error) {
      logError(error, "initViewToggle");
    }
  };

  // Function to maintain view state after InstantSearch renders
  const maintainViewState = () => {
    const currentView = localStorage.getItem("searchViewMode") || "grid";
    const hits = document.querySelector("#hits");
    if (hits) {
      hits.classList.remove("search-products--grid", "search-products--list");
      hits.classList.add(`search-products--${currentView}`);
    }
  };

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      initViewToggle();

      // Set up observer to watch for InstantSearch updates
      const observer = new MutationObserver(maintainViewState);

      const hitsContainer = document.querySelector("#hits");
      if (hitsContainer) {
        observer.observe(hitsContainer, { childList: true, subtree: true });
      }
    });
  } else {
    initViewToggle();

    // Set up observer to watch for InstantSearch updates
    const observer = new MutationObserver(maintainViewState);

    const hitsContainer = document.querySelector("#hits");
    if (hitsContainer) {
      observer.observe(hitsContainer, { childList: true, subtree: true });
    }
  }

  // Re-initialize view toggle when filter component updates
  document.addEventListener("filterUpdate", () => {
    setTimeout(initViewToggle, 100);
  });

  Object.assign(ns, { initViewToggle, maintainViewState });
})((window.ProductSearch = window.ProductSearch || {}));
